import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for LE LIS's "SHORT SLEEVE ROUND NECK OVERSIZED
// STRIPE T-SHIRT" (p_2sd6y7tgsw), read from that product's own live PDP
// (faire.com/product/p_2sd6y7tgsw) "Product reviews" section — not a
// brand-wide or similar-product fallback review.
export const review_ll1: FaireReviewEntity = {
  token: "review_ll1",
  type: "review",
  brandName: "LE LIS",
  brandToken: "b_q8gu9by5sv",
  productToken: "p_2sd6y7tgsw",
  reviewType: "product",
  reviewerName: "Marci",
  reviewerLocation: "Tega Cay, SC",
  stars: 5,
  reviewText: "should have bought more of this color",
  reviewDate: "Jul 15, 2026",
  meta: {
    source: "api",
    importedAt: "2026-08-11T20:56:47.000Z",
    importedBy: "entity-db-cli",
  },
};
